import React, { useEffect, useState } from 'react';
import CandidateCardsList from '../components/CandidateCardsList';
import {  fetchActiveDepartments, GetCandidate, GetDemandPlanning } from '../services/apiService';
import LoadingSpinner from '../components/LoadingSpinner';
import { getDepartmentIdFromToken, getToken } from '../services/authService';

const CandidatesPage = () => {
  const [candidates, setcandidates] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [demandPlans, setDemandPlans] = useState([]);
  const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState({});
 useEffect(() => {
    
    const userRole = getToken();
 
    const loadDepartments = async () => {
      try {
        
        const deptData = await fetchActiveDepartments();
        if (userRole.IsDepartmentRestricted === "True") {
            
          const departmentId = getDepartmentIdFromToken();
          setDepartments(deptData.filter(dept => String(dept.department_id) === String(departmentId)));
 
        } else {
            
          setDepartments(deptData);
        }
      } catch (err) {
        console.error("Failed to load departments:", err);
      }
    };

    const loadDemandPlan = async () => {
      try {
        
        const currentYear = new Date().getFullYear();
        const dplan = await GetDemandPlanning(currentYear);
        if (userRole.IsDepartmentRestricted === "True") {
            
          const departmentId = getDepartmentIdFromToken();
          setDemandPlans(dplan.filter(dept => String(dept.department_id) === String(departmentId)));
 
        } else {
            
          setDemandPlans(dplan);
        }
      } catch (err) {
        console.error("Failed to load departments:", err);
      }
    };

 
 
     
 const loadCandidates = async () => {
  try {
    setLoading(true);

    const userRole = getToken();
    const userRoleName = userRole.role;
    const departmentId = getDepartmentIdFromToken();
    const isDeptRestricted = String(userRole.IsDepartmentRestricted).toLowerCase() === "true";

    const requests = await GetCandidate();

    // Sort by most recent date
    let sortedRequests = [...requests].sort(
      (a, b) => new Date(b.application_date) - new Date(a.application_date)
    );

    // Filter out "Applied" if Business Owner
    if (userRoleName === "Business Owner") {
      
      sortedRequests = sortedRequests.filter(req => String(req.status) !== "Applied");
    }

    // Apply department restriction
    if (isDeptRestricted) {
      sortedRequests = sortedRequests.filter(
        req => String(req.department_id) === String(departmentId)
      );
    }

    setcandidates(sortedRequests);

  } catch (err) {
    setErrors("Failed to load hiring requests");
  } finally {
    setLoading(false);
  }
};


 
     loadDepartments();
     loadCandidates();
     loadDemandPlan();
   }, []);

  if (loading) return <LoadingSpinner label="Loading Candidates" />;

  return (
       <div className="
  bg-white
  mx-4
  sm:h-[72vh] sm:pt-4 sm:px-4 sm:rounded-t-[32px]
  md:h-[74.5vh] md:pt-8 md:px-[calc(5%-1rem)] md:rounded-t-[40px]
  lg:h-[74.5vh] lg:px-[calc(6%-1rem)]
  xl:h-[100%] xl:pt-24 xl:px-[calc(2.5%-1rem)] xl:rounded-t-[48px]
  2xl:h-[74.5vh] 2xl:px-[calc(8%-1rem)]
  3xl:h-[74.5vh] 3xl:px-[calc(8%-1rem)]
  4xl:h-[74.5vh] 4xl:px-[calc(10%-1rem)]
       ">
        {/* <div className="main-content overflow-x-hidden  xl:px-6 2xl:gap-6 gap-8 pt-8 xl:gap-4 max-xs:grid max-xs:px-4 md:px-4 justify-center mt-9"></div> */}


  
      <CandidateCardsList
        candidates={candidates}
        departments={departments}
        demandPlans={demandPlans}
      />
    </div>
  );
};

export default CandidatesPage;
